export default "__VITE_ASSET__b18abc09__"